import { BookOpen, LoaderCircle } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * What stands where the guide button would be while there is nothing to open:
 * the first load, a failed first load (with a retry), or a shift nobody has
 * written a guide for. Shared by the slot-card entry and the schedule block.
 */
export function ShiftGuideStatus({
  status,
  onRetry,
  className,
}: {
  status: "loading" | "error" | "empty";
  onRetry: () => void;
  className?: string | undefined;
}) {
  if (status === "loading") {
    return (
      <p
        className={cn(
          "flex min-h-11 items-center gap-2 rounded-md bg-surface-2 px-[11px] py-2 text-xs text-muted-foreground motion-safe:animate-pulse",
          className,
        )}
      >
        <LoaderCircle size={14} aria-hidden className="shrink-0 motion-safe:animate-spin" />
        Đang tải hướng dẫn…
      </p>
    );
  }
  if (status === "error") {
    return (
      <p
        className={cn(
          "flex flex-wrap items-center gap-x-1.5 rounded-md border px-[11px] text-xs text-muted-foreground",
          className,
        )}
      >
        Chưa tải được hướng dẫn ·
        <button
          type="button"
          onClick={onRetry}
          className="min-h-11 font-bold text-[var(--color-brand)] underline-offset-2 hover:underline"
        >
          Thử lại
        </button>
      </p>
    );
  }
  return (
    <p
      className={cn(
        "flex items-start gap-2 rounded-md border border-dashed border-[var(--color-border-light)] px-[11px] py-[9px] text-[12.5px] leading-snug text-muted-foreground",
        className,
      )}
    >
      <BookOpen size={15} aria-hidden className="mt-px shrink-0 opacity-50" />
      Chưa có bài hướng dẫn cho ca này. Cần thì hỏi quản lý phòng.
    </p>
  );
}
